import { Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";

export default function InfoBanner({ data }) {
  return (
    <Box
      sx={{
        background: data ? "url(" + data.background.url + ")" : "#f0f0f0",
        backgroundSize: "cover",
        backgroundPosition: "center",
        m: "3rem 0",
        p: "6rem 0",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            backgroundColor: "rgba(255,255,255,0.9)",
            color: "#1A2F47",
            p: "3rem",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: "1.4rem",
              color: "#265DA5",
            }}
          >
            {data ? data.heading : <Skeleton />}
          </Typography>
          <Typography
            variant="p"
            component="p"
            sx={{
              mt: "1rem",
              whiteSpace: "break-spaces",
            }}
            dangerouslySetInnerHTML={{
              __html: data ? (
                data.content
              ) : (
                <Skeleton variant="rectangular" height={300} />
              ),
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
